import styles from "./Footer.module.css";
import Logo from "../../Assets/Logo.png";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.column}>
          <img src={Logo} alt="MB Sistemas" className={styles.logo} />
          <p>
            MB Sistemas - Tecnologia e Desenvolvimento.
            Solucoes em ERP e software sob medida para empresas que buscam
            eficiencia e modernidade.
          </p>
        </div>

        <div className={styles.column}>
          <h3>Navegacao</h3>
          <a href="#produtos">Produtos</a>
          <a href="#diferenciais">Diferenciais</a>
          <a href="#contato">Contato</a>
        </div>

        <div className={styles.column}>
          <h3>Contato</h3>
          <a
            href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20o%20MBControl"
            target="_blank"
            rel="noreferrer"
          >
            WhatsApp: (17) 99125-4844
          </a>
          <a href="mailto:contato@mbernardisistemas.com.br">
            contato@mbernardisistemas.com.br
          </a>
        </div>
      </div>

      <div className={styles.bottom}>
        &copy; 2026 MB Sistemas - Tecnologia e Desenvolvimento. Todos os direitos reservados.
      </div>
    </footer>
  );
}
